module.exports = __webpack_public_path__ + "img/wallet.1cd53060.png";